// src/hooks/useTickerFinancialsSummary.js
// SCREENER-FINANCIALS — updated this pass: backend now returns `groups`
// (Annual Reports / Quarterly Reports, each with its own edgarUrl) instead
// of a flat `periods` array, matching the Filings tab's grouping standard.

import { useState, useEffect } from 'react';
import apiFetch from '../utils/apiFetch';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function useTickerFinancialsSummary(ticker) {
  const [cik, setCik]       = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    if (!ticker) { setLoading(false); return; }
    setLoading(true);
    setError('');
    apiFetch(API_URL + '/api/financials/ticker/' + encodeURIComponent(ticker))
      .then(r => r.json())
      .then(res => {
        if (!res.success) { setError(res.message || 'Financials data unavailable'); return; }
        setCik(res.cik || null);
        setGroups(res.groups || []);
      })
      .catch(() => setError('Failed to load financials'))
      .finally(() => setLoading(false));
  }, [ticker]);

  return { cik, groups, loading, error };
}
